module.exports = __webpack_public_path__ + "static/media/hipergigante_amarela.07a5d85b.png";